// src/frontend/data/books/DarkForest/data/cap22.js

const CAP22 = {
  id: 22,
  title: "Protección de Privacidad Tradicional",
  sections: [
    {
      heading: "La privacidad como base de la seguridad",
      text: [
        "¡Felicidades por llegar hasta aquí! La protección de la privacidad es un tema antiguo, pero más vigente que nunca en el mundo Web3. La privacidad no es un simple 'extra', es el cimiento sobre el que se construye toda la seguridad digital.",
        "Si los elementos más básicos —como tu identidad, hábitos, dispositivos, correos, ubicación, conversaciones o llaves criptográficas— no están protegidos, cualquier estrategia de seguridad avanzada será tan frágil como un castillo en el aire.",
        "Por eso, entender cómo proteger tu privacidad es el primer paso antes de hablar de seguridad, blockchain, wallets, DeFi o Web3."
      ]
    },
    {
      heading: "Importancia histórica: un artículo de 2014",
      text: [
        "El autor escribió un artículo sobre protección de privacidad en 2014, y a pesar del tiempo, muchos de sus consejos siguen siendo válidos hoy:",
        "🔗 https://evilcos.me/yinsi.html",
        "Aunque era un artículo de nivel básico, muchos de los principios siguen vigentes porque la ingeniería social, los errores humanos y la exposición de datos siguen siendo las principales causas de hackeos en 2024."
      ]
    },
    {
      heading: "Privacidad y seguridad: inseparables",
      text: [
        "Privacidad y seguridad no son lo mismo, pero están íntimamente conectadas.",
        "🔐 Seguridad → protege sistemas, datos, activos y operaciones.",
        "🕶 Privacidad → protege tu identidad, comportamiento, huellas digitales y contexto.",
        "Imagina esta relación como un edificio:",
        "🏗 La privacidad es el cimiento.",
        "🏢 La seguridad es la estructura.",
        "Si los cimientos no son sólidos (mala privacidad), la estructura se colapsa (sin seguridad)."
      ]
    },
    {
      heading: "Privacidad moderna: más allá del anonimato",
      text: [
        "Hoy la privacidad no trata solo de ocultar tu nombre. La privacidad moderna incluye:",
        "- Tu dirección IP, ubicación y dispositivo.",
        "- Tu patrón de uso: horarios, movimientos, hábitos digitales.",
        "- Tus mensajes, correos, historial de navegación.",
        "- Tus direcciones blockchain, seed phrase y claves privadas.",
        "- Tu metadata (datos sobre tus datos: cuándo, dónde, cómo).",
        "Por eso, proteger la privacidad no es solo usar VPN; es proteger tu identidad digital desde la raíz."
      ]
    },
    {
      heading: "Guías recomendadas y herramientas esenciales",
      text: [
        "Existen recursos confiables y bien estructurados que ayudan a aprender privacidad digital de forma seria, práctica y actualizada:"
      ],
      list: [
        "🛡 Surveillance Self-Defense (EFF) — https://ssd.eff.org/",
        "📚 Privacy Tools — https://www.privacytools.io/",
        "🔏 Criptografía para privacidad — Signal, Tor, PGP, ProtonMail, etc."
      ],
      image: {
        src: "https://raw.githubusercontent.com/AppsDevsLeon/ImagesBooks/refs/heads/main/imagesFundamentosBlockchain/DarckForest/Captura%20de%20pantalla_18-11-2025_1833_ssd.eff.org.jpeg",
        alt: "Portada de Surveillance Self Defense (EFF)",
        caption: "EFF Surveillance Self-Defense: una de las mejores guías públicas para proteger tu privacidad digital."
      }
    },
    {
      heading: "PrivacyTools.io: catálogo completo de herramientas",
      text: [
        "Este portal lista soluciones de privacidad clasificadas por utilidad:",
        "- Navegadores seguros (Tor, Brave, LibreWolf)",
        "- Sistemas operativos privados (Tails, Qubes OS, Whonix)",
        "- Buscadores privados (DuckDuckGo, Startpage, Searx)",
        "- Correo seguro (ProtonMail, Tutanota)",
        "- VPN fiables (Mullvad, ProtonVPN, iVPN)",
        "- Monederos cripto con privacidad mejorada (Wasabi Wallet, Samurai Wallet)",
        "Aunque muchas de estas herramientas son útiles, no necesitas usar todas. Debes desarrollar tu propio conjunto de herramientas —tu 'kit personal de privacidad'— y mejorarlo con el tiempo."
      ]
    },
    {
      heading: "Consejos fundamentales de protección de privacidad",
      text: [
        "No necesitas ser hacker para proteger tu privacidad. Necesitas conocimiento, hábitos y sentido común. Aquí algunas reglas clave:"
      ],
      list: [
        "✔ No reutilices contraseñas. Usa un gestor como 1Password o Bitwarden.",
        "✔ Usa autenticación de dos factores (2FA) SIEMPRE, pero mejor con app o llave física (YubiKey), no SMS.",
        "✔ No reveles tus direcciones blockchain públicamente si están vinculadas a tu identidad.",
        "✔ Separa identidades: una para Web2, otra para Web3, otra para trabajo.",
        "✔ No uses tu billetera principal para conectarte a todas las DApps.",
        "✔ Nunca guardes frases semilla en fotos, notas o correo.",
        "✔ Evita mezclar cuentas personales, laborales y cripto en un mismo dispositivo.",
        "✔ Usa VPN confiable, pero no la veas como solución mágica: es solo un componente."
      ]
    },
    {
      heading: "Herramientas que sí deberías dominar",
      text: [
        "Estas son herramientas recomendadas por expertos que deberías, al menos, conocer y probar:"
      ],
      list: [
        "🛡 Tor Browser — Navegación anónima y privada.",
        "🗝 Signal — Mensajería cifrada y privada.",
        "🔐 GPG / PGP — Cifrado de correos, archivos y firmas.",
        "📮 ProtonMail — Correo seguro y cifrado.",
        "💳 Wasabi / Samurai Wallet — Herramientas con coin-mixing (bitcoin).",
        "🧱 Qubes OS / Tails — Sistemas operativos ultra-privados.",
        "🔑 YubiKey — Autenticación física de alta seguridad."
      ]
    },
    {
      heading: "Aprender privacidad no es usar apps. Es pensar diferente.",
      text: [
        "Proteger tu privacidad no significa instalar muchas apps 'seguras'.",
        "Es entender cómo fluyen tus datos, qué dejas expuesto, con quién compartes y qué huellas dejas en cada acción.",
        "Privacidad no es esconderte. Es controlar tu información.",
        "Y recuerda: en Web3, tus wallets, direcciones e interacciones se vuelven parte de tu identidad — incluso si no dices tu nombre."
      ]
    },
    {
      heading: "Conclusión: la privacidad es tu armadura",
      text: [
        "Tu privacidad es más que una elección: es protección contra hackeos, extorsión, robo de identidad, manipulación y vigilancia.",
        "En el mundo descentralizado, tu identidad y tus activos están directamente conectados. Si pierdes tu privacidad, pierdes tu seguridad.",
        "Este capítulo no te pide paranoia. Te pide consciencia.",
        "La privacidad no es aislamiento. Es libertad controlada."
      ]
    }
  ]
};

export default CAP22;
